module.exports = __webpack_public_path__ + "static/img/agent_che.35cca9a6.png";